/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Enumeration of countries formatted in ISO 3166-1 alpha-3
export enum CountryCode {
  // Aruba
  ABW = 'ABW',
  // Afghanistan
  AFG = 'AFG',
  // Angola
  AGO = 'AGO',
  // Anguilla
  AIA = 'AIA',
  // Åland Islands
  ALA = 'ALA',
  // Albania
  ALB = 'ALB',
  // Andorra
  AND = 'AND',
  // United Arab Emirates
  ARE = 'ARE',
  // Argentina
  ARG = 'ARG',
  // Armenia
  ARM = 'ARM',
  // American Samoa
  ASM = 'ASM',
  // Antarctica
  ATA = 'ATA',
  // French Southern Territories
  ATF = 'ATF',
  // Antigua and Barbuda
  ATG = 'ATG',
  // Australia
  AUS = 'AUS',
  // Austria
  AUT = 'AUT',
  // Azerbaijan
  AZE = 'AZE',
  // Burundi
  BDI = 'BDI',
  // Belgium
  BEL = 'BEL',
  // Benin
  BEN = 'BEN',
  // Bonaire, Sint Eustatius and Saba
  BES = 'BES',
  // Burkina Faso
  BFA = 'BFA',
  // Bangladesh
  BGD = 'BGD',
  // Bulgaria
  BGR = 'BGR',
  // Bahrain
  BHR = 'BHR',
  // Bahamas
  BHS = 'BHS',
  // Bosnia and Herzegovina
  BIH = 'BIH',
  // Saint Barthélemy
  BLM = 'BLM',
  // Belarus
  BLR = 'BLR',
  // Belize
  BLZ = 'BLZ',
  // Bermuda
  BMU = 'BMU',
  // Bolivia, Plurinational State of
  BOL = 'BOL',
  // Brazil
  BRA = 'BRA',
  // Barbados
  BRB = 'BRB',
  // Brunei Darussalam
  BRN = 'BRN',
  // Bhutan
  BTN = 'BTN',
  // Bouvet Island
  BVT = 'BVT',
  // Botswana
  BWA = 'BWA',
  // Central African Republic
  CAF = 'CAF',
  // Canada
  CAN = 'CAN',
  // Cocos (Keeling) Islands
  CCK = 'CCK',
  // Switzerland
  CHE = 'CHE',
  // Chile
  CHL = 'CHL',
  // China
  CHN = 'CHN',
  // Côte d'Ivoire
  CIV = 'CIV',
  // Cameroon
  CMR = 'CMR',
  // Congo, the Democratic Republic of the
  COD = 'COD',
  // Congo
  COG = 'COG',
  // Cook Islands
  COK = 'COK',
  // Colombia
  COL = 'COL',
  // Comoros
  COM = 'COM',
  // Cabo Verde
  CPV = 'CPV',
  // Costa Rica
  CRI = 'CRI',
  // Cuba
  CUB = 'CUB',
  // Curaçao
  CUW = 'CUW',
  // Christmas Island
  CXR = 'CXR',
  // Cayman Islands
  CYM = 'CYM',
  // Cyprus
  CYP = 'CYP',
  // Czechia
  CZE = 'CZE',
  // Germany
  DEU = 'DEU',
  // Djibouti
  DJI = 'DJI',
  // Dominica
  DMA = 'DMA',
  // Denmark
  DNK = 'DNK',
  // Dominican Republic
  DOM = 'DOM',
  // Algeria
  DZA = 'DZA',
  // Ecuador
  ECU = 'ECU',
  // Egypt
  EGY = 'EGY',
  // Eritrea
  ERI = 'ERI',
  // Western Sahara
  ESH = 'ESH',
  // Spain
  ESP = 'ESP',
  // Estonia
  EST = 'EST',
  // Ethiopia
  ETH = 'ETH',
  // Finland
  FIN = 'FIN',
  // Fiji
  FJI = 'FJI',
  // Falkland Islands (Malvinas)
  FLK = 'FLK',
  // France
  FRA = 'FRA',
  // Faroe Islands
  FRO = 'FRO',
  // Micronesia, Federated States of
  FSM = 'FSM',
  // Gabon
  GAB = 'GAB',
  // United Kingdom
  GBR = 'GBR',
  // Georgia
  GEO = 'GEO',
  // Guernsey
  GGY = 'GGY',
  // Ghana
  GHA = 'GHA',
  // Gibraltar
  GIB = 'GIB',
  // Guinea
  GIN = 'GIN',
  // Guadeloupe
  GLP = 'GLP',
  // Gambia
  GMB = 'GMB',
  // Guinea-Bissau
  GNB = 'GNB',
  // Equatorial Guinea
  GNQ = 'GNQ',
  // Greece
  GRC = 'GRC',
  // Grenada
  GRD = 'GRD',
  // Greenland
  GRL = 'GRL',
  // Guatemala
  GTM = 'GTM',
  // French Guiana
  GUF = 'GUF',
  // Guam
  GUM = 'GUM',
  // Guyana
  GUY = 'GUY',
  // Hong Kong
  HKG = 'HKG',
  // Heard Island and McDonald Islands
  HMD = 'HMD',
  // Honduras
  HND = 'HND',
  // Croatia
  HRV = 'HRV',
  // Haiti
  HTI = 'HTI',
  // Hungary
  HUN = 'HUN',
  // Indonesia
  IDN = 'IDN',
  // Isle of Man
  IMN = 'IMN',
  // India
  IND = 'IND',
  // British Indian Ocean Territory
  IOT = 'IOT',
  // Ireland
  IRL = 'IRL',
  // Iran, Islamic Republic of
  IRN = 'IRN',
  // Iraq
  IRQ = 'IRQ',
  // Iceland
  ISL = 'ISL',
  // Israel
  ISR = 'ISR',
  // Italy
  ITA = 'ITA',
  // Jamaica
  JAM = 'JAM',
  // Jersey
  JEY = 'JEY',
  // Jordan
  JOR = 'JOR',
  // Japan
  JPN = 'JPN',
  // Kazakhstan
  KAZ = 'KAZ',
  // Kenya
  KEN = 'KEN',
  // Kyrgyzstan
  KGZ = 'KGZ',
  // Cambodia
  KHM = 'KHM',
  // Kiribati
  KIR = 'KIR',
  // Saint Kitts and Nevis
  KNA = 'KNA',
  // Korea, Republic of
  KOR = 'KOR',
  // Kuwait
  KWT = 'KWT',
  // Lao People's Democratic Republic
  LAO = 'LAO',
  // Lebanon
  LBN = 'LBN',
  // Liberia
  LBR = 'LBR',
  // Libya
  LBY = 'LBY',
  // Saint Lucia
  LCA = 'LCA',
  // Liechtenstein
  LIE = 'LIE',
  // Sri Lanka
  LKA = 'LKA',
  // Lesotho
  LSO = 'LSO',
  // Lithuania
  LTU = 'LTU',
  // Luxembourg
  LUX = 'LUX',
  // Latvia
  LVA = 'LVA',
  // Macao
  MAC = 'MAC',
  // Saint Martin (French part)
  MAF = 'MAF',
  // Morocco
  MAR = 'MAR',
  // Monaco
  MCO = 'MCO',
  // Moldova, Republic of
  MDA = 'MDA',
  // Madagascar
  MDG = 'MDG',
  // Maldives
  MDV = 'MDV',
  // Mexico
  MEX = 'MEX',
  // Marshall Islands
  MHL = 'MHL',
  // Macedonia, the former Yugoslav Republic of
  MKD = 'MKD',
  // Mali
  MLI = 'MLI',
  // Malta
  MLT = 'MLT',
  // Myanmar
  MMR = 'MMR',
  // Montenegro
  MNE = 'MNE',
  // Mongolia
  MNG = 'MNG',
  // Northern Mariana Islands
  MNP = 'MNP',
  // Mozambique
  MOZ = 'MOZ',
  // Mauritania
  MRT = 'MRT',
  // Montserrat
  MSR = 'MSR',
  // Martinique
  MTQ = 'MTQ',
  // Mauritius
  MUS = 'MUS',
  // Malawi
  MWI = 'MWI',
  // Malaysia
  MYS = 'MYS',
  // Mayotte
  MYT = 'MYT',
  // Namibia
  NAM = 'NAM',
  // New Caledonia
  NCL = 'NCL',
  // Niger
  NER = 'NER',
  // Norfolk Island
  NFK = 'NFK',
  // Nigeria
  NGA = 'NGA',
  // Nicaragua
  NIC = 'NIC',
  // Niue
  NIU = 'NIU',
  // Netherlands
  NLD = 'NLD',
  // Norway
  NOR = 'NOR',
  // Nepal
  NPL = 'NPL',
  // Nauru
  NRU = 'NRU',
  // New Zealand
  NZL = 'NZL',
  // Oman
  OMN = 'OMN',
  // Pakistan
  PAK = 'PAK',
  // Panama
  PAN = 'PAN',
  // Pitcairn
  PCN = 'PCN',
  // Peru
  PER = 'PER',
  // Philippines
  PHL = 'PHL',
  // Palau
  PLW = 'PLW',
  // Papua New Guinea
  PNG = 'PNG',
  // Poland
  POL = 'POL',
  // Puerto Rico
  PRI = 'PRI',
  // Korea, Democratic People's Republic of
  PRK = 'PRK',
  // Portugal
  PRT = 'PRT',
  // Paraguay
  PRY = 'PRY',
  // Palestine, State of
  PSE = 'PSE',
  // French Polynesia
  PYF = 'PYF',
  // Qatar
  QAT = 'QAT',
  // Réunion
  REU = 'REU',
  // Romania
  ROU = 'ROU',
  // Russian Federation
  RUS = 'RUS',
  // Rwanda
  RWA = 'RWA',
  // Saudi Arabia
  SAU = 'SAU',
  // Sudan
  SDN = 'SDN',
  // Senegal
  SEN = 'SEN',
  // Singapore
  SGP = 'SGP',
  // South Georgia and the South Sandwich Islands
  SGS = 'SGS',
  // Saint Helena, Ascension and Tristan da Cunha
  SHN = 'SHN',
  // Svalbard and Jan Mayen
  SJM = 'SJM',
  // Solomon Islands
  SLB = 'SLB',
  // Sierra Leone
  SLE = 'SLE',
  // El Salvador
  SLV = 'SLV',
  // San Marino
  SMR = 'SMR',
  // Somalia
  SOM = 'SOM',
  // Saint Pierre and Miquelon
  SPM = 'SPM',
  // Serbia
  SRB = 'SRB',
  // South Sudan
  SSD = 'SSD',
  // Sao Tome and Principe
  STP = 'STP',
  // Suriname
  SUR = 'SUR',
  // Slovakia
  SVK = 'SVK',
  // Slovenia
  SVN = 'SVN',
  // Sweden
  SWE = 'SWE',
  // Eswatini
  SWZ = 'SWZ',
  // Sint Maarten (Dutch part)
  SXM = 'SXM',
  // Seychelles
  SYC = 'SYC',
  // Syrian Arab Republic
  SYR = 'SYR',
  // Turks and Caicos Islands
  TCA = 'TCA',
  // Chad
  TCD = 'TCD',
  // Togo
  TGO = 'TGO',
  // Thailand
  THA = 'THA',
  // Tajikistan
  TJK = 'TJK',
  // Tokelau
  TKL = 'TKL',
  // Turkmenistan
  TKM = 'TKM',
  // Timor-Leste
  TLS = 'TLS',
  // Tonga
  TON = 'TON',
  // Trinidad and Tobago
  TTO = 'TTO',
  // Tunisia
  TUN = 'TUN',
  // Turkey
  TUR = 'TUR',
  // Tuvalu
  TUV = 'TUV',
  // Taiwan, Province of China
  TWN = 'TWN',
  // Tanzania, United Republic of
  TZA = 'TZA',
  // Uganda
  UGA = 'UGA',
  // Ukraine
  UKR = 'UKR',
  // United States Minor Outlying Islands
  UMI = 'UMI',
  // Uruguay
  URY = 'URY',
  // United States of America
  USA = 'USA',
  // Uzbekistan
  UZB = 'UZB',
  // Holy See
  VAT = 'VAT',
  // Saint Vincent and the Grenadines
  VCT = 'VCT',
  // Venezuela, Bolivarian Republic of
  VEN = 'VEN',
  // Virgin Islands, British
  VGB = 'VGB',
  // Virgin Islands, U.S.
  VIR = 'VIR',
  // Viet Nam
  VNM = 'VNM',
  // Vanuatu
  VUT = 'VUT',
  // Wallis and Futuna
  WLF = 'WLF',
  // Samoa
  WSM = 'WSM',
  // Yemen
  YEM = 'YEM',
  // South Africa
  ZAF = 'ZAF',
  // Zambia
  ZMB = 'ZMB',
  // Zimbabwe
  ZWE = 'ZWE',
}
